export default __webpack_public_path__ + "static/media/bot.93d46a9a.jpg";